import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import type { CtaAnalyticsProps } from '../CTA/CtaLink';
import { RatingTextAndTooltip } from '../NerdWalletRating/Roundups/RatingTextAndTooltip';
import { Stars } from '../NerdWalletRating/Stars';
const starRatingContainerClass = css({
  display: 'flex',
  flexDirection: 'column',
  width: '[fit-content]',
  py: '2',
  _pcMd: {
    flexDirection: 'row-reverse'
  },
  flexWrap: 'wrap'
});
export type StarRatingProps = {
  reviewLink?: string | null;
  starRating?: number;
  asColumn?: boolean;
  centered?: boolean;
  segmentActionSection?: string;
  isMonetizing?: boolean;
  name: string;
};
export const StarRating = t0 => {
  const $ = _c(11);
  const {
    reviewLink,
    starRating,
    segmentActionSection,
    isMonetizing: t1,
    name
  } = t0;
  const isMonetizing = t1 === undefined ? true : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      isTrackOnly: true
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const starRatingAnalytics = t2;
  let t3;
  if ($[1] !== isMonetizing || $[2] !== name || $[3] !== reviewLink || $[4] !== segmentActionSection) {
    t3 = <RatingTextAndTooltip analytics={starRatingAnalytics} reviewLink={reviewLink} isMonetizing={isMonetizing} segmentActionSection={segmentActionSection} name={name} />;
    $[1] = isMonetizing;
    $[2] = name;
    $[3] = reviewLink;
    $[4] = segmentActionSection;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== starRating) {
    t4 = <Stars starRating={starRating} />;
    $[6] = starRating;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div><div className={starRatingContainerClass}>{t3}{t4}</div></div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};